import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const FilterBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
  padding: 1rem 0;
`;

export const YearSelector = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  font: var(--text);

  select {
    padding: 0.5rem 1.5rem;
    border-radius: 0.5rem;
    border: 1px solid var(--primary);
    background-color: var(--secondary);
    color: var(--primary);
    font-size: 1rem;
    cursor: pointer;
    outline: none;

    &:focus {
      border-color: var(--darkBlue);
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  width: 100%;
  margin-top: 2rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 1.5rem;
  border: 1px solid var(--primary);
  border-radius: 1rem;
  background-color: var(--secondary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  ${(props) =>
    props.fullscreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      background-color: #ffffff;
      padding: 2rem;
      border: none;
      border-radius: 0;
    `}
`;

export const ChartTitle = styled.h3`
  font: var(--title);
  text-align: center;
  margin-bottom: 1rem;
  color: var(--primary);
  width: 100%;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: ${(props) => props.height || "400px"};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 4rem 2rem;
  text-align: center;
  font: var(--text);
  color: var(--primary);
  opacity: 0.7;
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  background-color: #fff0f0;
  border: 1px solid #ffcccc;
  border-radius: 1rem;
  color: #cc0000;
  font: var(--text);
  text-align: center;
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-radius: 1rem;
  background-color: var(--darkBlue);
  color: var(--secondary);
  text-align: center;

  .value {
    font-size: 2rem;
    font-weight: bold;
  }

  .label {
    font-size: 0.875rem;
    opacity: 0.9;
    margin-top: 0.25rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

